import EBulletinFormPage from "./EBulletinFormPage"

const EBulletinCreate = () => {
  return (
    <>
    {/* <EBulletinFormPage></EBulletinFormPage> */}
    </>
  )
}

export default EBulletinCreate